import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from "@spartacus/core";
// TODO:Spartacus - // TODO:Spartacus - Variable orderTranslations has been removed and is no longer part of the public API. 
import { orderTranslationChunksConfig, orderTranslationsCs } from "@spartacus/order/assets";
import { OrderRootModule, ORDER_FEATURE } from "@spartacus/order/root";

@NgModule({
  declarations: [],
  imports: [
    OrderRootModule
  ],
  providers: [provideConfig(<CmsConfig>{
    featureModules: {
      [ORDER_FEATURE]: {
        module: () =>
          import('@spartacus/order').then((m) => m.OrderModule),
      },
    }
  }),
  provideConfig(<I18nConfig>{
    i18n: {
      resources: orderTranslationsCs,
      chunks: orderTranslationChunksConfig,
    },
  })
  ]
})
export class OrderFeatureModule { }
